/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

 import ServicePath from "@/core/ServicePath"
 import { MainRequest } from "@/core/request";

 export default class SignRequest extends MainRequest{

     static add(object) {
        return this.postFILESEC(ServicePath.SAVE_SIGN, object);
     }

     static addToUser(object) {
         return this.postSEC(ServicePath.SIGN_SAVE_TO_USER, object);
     }
     static get(data) {
        return this.postSEC(ServicePath.SIGN_IMAGE_BY_HUMAN_RESOURCE, data);
    }
     
 }